import type { ConciergeInvitationProduct, ConciergeSaveTheDateProduct } from '@apps/card/routes/Dashboard/components/ConciergeServiceSection/ConciergeServiceSection.types';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { CurrencyFormatter } from '@shared/utils/currency';
import { times } from 'lodash-es';

// Invitations

const JULY_TRIFOLD: { [n: number]: number } = {
  '10': 1092,
  '20': 728,
  '30': 637,
  '40': 618,
  '50': 601,
  '60': 555,
  '70': 509,
  '80': 507,
  '90': 473,
  '100': 471,
  '110': 434,
  '120': 411,
  '130': 399,
  '140': 387,
  '150': 383,
  '160': 381,
  '170': 379,
  '180': 379,
  '190': 377,
  '200': 368,
  '210': 369,
  '220': 369,
  '230': 368,
  '240': 369,
  '250': 369,
  '260': 368,
  '270': 369,
  '280': 369,
  '290': 369,
  '300': 369,
};

const WILDEST_DREAM: { [n: number]: number } = {
  '10': 3728,
  '20': 2643,
  '30': 2164,
  '40': 1775,
  '50': 1397,
  '60': 1267,
  '70': 1156,
  '80': 1085,
  '90': 1011,
  '100': 946,
  '110': 930,
  '120': 906,
  '130': 876,
  '140': 864,
  '150': 857,
  '160': 849,
  '170': 842,
  '180': 836,
  '190': 829,
  '200': 812,
  '210': 805,
  '220': 805,
  '230': 805,
  '240': 805,
  '250': 796,
  '260': 796,
  '270': 794,
  '280': 794,
  '290': 794,
  '300': 794,
};

const TOGETHER: { [n: number]: number } = {
  '10': 2016,
  '20': 1295,
  '30': 1042,
  '40': 835,
  '50': 746,
  '60': 692,
  '70': 654,
  '80': 631,
  '90': 608,
  '100': 592,
  '110': 586,
  '120': 586,
  '130': 578,
  '140': 578,
  '150': 578,
  '160': 551,
  '170': 551,
  '180': 551,
  '190': 551,
  '200': 543,
  '210': 543,
  '220': 543,
  '230': 543,
  '240': 543,
  '250': 536,
  '260': 536,
  '270': 536,
  '280': 536,
  '290': 536,
  '300': 536,
};

const MILK_AND_HONEY: { [n: number]: number } = {
  '10': 3239,
  '20': 2340,
  '30': 1938,
  '40': 1544,
  '50': 1350,
  '60': 1222,
  '70': 1084,
  '80': 1023,
  '90': 939,
  '100': 874,
  '110': 841,
  '120': 819,
  '130': 792,
  '140': 779,
  '150': 776,
  '160': 775,
  '170': 773,
  '180': 772,
  '190': 770,
  '200': 759,
  '210': 758,
  '220': 757,
  '230': 756,
  '240': 755,
  '250': 750,
  '260': 749,
  '270': 748,
  '280': 748,
  '290': 747,
  '300': 747,
};

const SAGE: { [n: number]: number } = {
  '10': 3942,
  '20': 2612,
  '30': 2097,
  '40': 1747,
  '50': 1514,
  '60': 1390,
  '70': 1272,
  '80': 1223,
  '90': 1183,
  '100': 1128,
  '110': 1100,
  '120': 1074,
  '130': 1054,
  '140': 1024,
  '150': 1006,
  '160': 1000,
  '170': 992,
  '180': 975,
  '190': 971,
  '200': 962,
  '210': 947,
  '220': 944,
  '230': 942,
  '240': 928,
  '250': 926,
  '260': 924,
  '270': 922,
  '280': 908,
  '290': 907,
  '300': 905,
};

const IVORY: { [n: number]: number } = {
  '10': 4403,
  '20': 2879,
  '30': 2250,
  '40': 1818,
  '50': 1567,
  '60': 1441,
  '70': 1310,
  '80': 1247,
  '90': 1168,
  '100': 1102,
  '110': 1059,
  '120': 1021,
  '130': 997,
  '140': 972,
  '150': 966,
  '160': 960,
  '170': 955,
  '180': 951,
  '190': 947,
  '200': 938,
  '210': 935,
  '220': 932,
  '230': 930,
  '240': 927,
  '250': 925,
  '260': 923,
  '270': 919,
  '280': 917,
  '290': 916,
  '300': 914,
};

const SOFIA: { [n: number]: number } = {
  '10': 3629,
  '20': 2215,
  '30': 1761,
  '40': 1394,
  '50': 1183,
  '60': 1062,
  '70': 966,
  '80': 917,
  '90': 847,
  '100': 810,
  '110': 772,
  '120': 732,
  '130': 723,
  '140': 716,
  '150': 710,
  '160': 699,
  '170': 695,
  '180': 690,
  '190': 669,
  '200': 667,
  '210': 663,
  '220': 661,
  '230': 658,
  '240': 656,
  '250': 654,
  '260': 649,
  '270': 647,
  '280': 643,
  '290': 641,
  '300': 640,
};

const HARMONY_GATEFOLD: { [n: number]: number } = {
  '10': 923,
  '20': 709,
  '30': 624,
  '40': 556,
  '50': 528,
  '60': 528,
  '70': 527,
  '80': 528,
  '90': 528,
  '100': 528,
  '110': 521,
  '120': 521,
  '130': 521,
  '140': 521,
  '150': 521,
  '160': 494,
  '170': 494,
  '180': 494,
  '190': 494,
  '200': 494,
  '210': 494,
  '220': 494,
  '230': 494,
  '240': 494,
  '250': 494,
  '260': 494,
  '270': 494,
  '280': 494,
  '290': 494,
  '300': 494,
};

const HARMONY: { [n: number]: number } = {
  '10': 4371,
  '20': 2893,
  '30': 2264,
  '40': 1832,
  '50': 1581,
  '60': 1459,
  '70': 1333,
  '80': 1273,
  '90': 1194,
  '100': 1128,
  '110': 1085,
  '120': 1047,
  '130': 1023,
  '140': 998,
  '150': 992,
  '160': 986,
  '170': 981,
  '180': 977,
  '190': 973,
  '200': 964,
  '210': 961,
  '220': 958,
  '230': 956,
  '240': 953,
  '250': 951,
  '260': 949,
  '270': 945,
  '280': 943,
  '290': 942,
  '300': 940,
};

const EMPIRE_NOW: { [n: number]: number } = {
  '10': 1154,
  '20': 792,
  '30': 668,
  '40': 536,
  '50': 504,
  '60': 461,
  '70': 420,
  '80': 412,
  '90': 383,
  '100': 377,
  '110': 349,
  '120': 331,
  '130': 321,
  '140': 310,
  '150': 306,
  '160': 304,
  '170': 300,
  '180': 298,
  '190': 296,
  '200': 289,
  '210': 288,
  '220': 288,
  '230': 287,
  '240': 286,
  '250': 285,
  '260': 285,
  '270': 284,
  '280': 284,
  '290': 283,
  '300': 283,
};

const BYRON_GATEFOLD: { [n: number]: number } = {
  '10': 923,
  '20': 709,
  '30': 624,
  '40': 556,
  '50': 528,
  '60': 528,
  '70': 527,
  '80': 528,
  '90': 528,
  '100': 528,
  '110': 521,
  '120': 521,
  '130': 521,
  '140': 521,
  '150': 521,
  '160': 494,
  '170': 494,
  '180': 494,
  '190': 494,
  '200': 494,
  '210': 494,
  '220': 494,
  '230': 494,
  '240': 494,
  '250': 494,
  '260': 494,
  '270': 494,
  '280': 494,
  '290': 494,
  '300': 494,
};

const JARDIN: { [n: number]: number } = {
  '10': 923,
  '20': 709,
  '30': 624,
  '40': 556,
  '50': 528,
  '60': 528,
  '70': 527,
  '80': 528,
  '90': 528,
  '100': 528,
  '110': 521,
  '120': 521,
  '130': 521,
  '140': 521,
  '150': 521,
  '160': 494,
  '170': 494,
  '180': 494,
  '190': 494,
  '200': 494,
  '210': 494,
  '220': 494,
  '230': 494,
  '240': 494,
  '250': 494,
  '260': 494,
  '270': 494,
  '280': 494,
  '290': 494,
  '300': 494,
};

const CELADON: { [n: number]: number } = {
  '10': 1318,
  '20': 1074,
  '30': 919,
  '40': 735,
  '50': 644,
  '60': 640,
  '70': 616,
  '80': 601,
  '90': 594,
  '100': 579,
  '110': 573,
  '120': 565,
  '130': 558,
  '140': 551,
  '150': 544,
  '160': 544,
  '170': 544,
  '180': 537,
  '190': 537,
  '200': 537,
  '210': 529,
  '220': 529,
  '230': 529,
  '240': 523,
  '250': 523,
  '260': 522,
  '270': 522,
  '280': 515,
  '290': 515,
  '300': 515,
};

const WILD_MEADOW: { [n: number]: number } = {
  '10': 2477,
  '20': 1605,
  '30': 1302,
  '40': 1054,
  '50': 946,
  '60': 876,
  '70': 826,
  '80': 797,
  '90': 767,
  '100': 747,
  '110': 740,
  '120': 740,
  '130': 730,
  '140': 730,
  '150': 730,
  '160': 703,
  '170': 703,
  '180': 703,
  '190': 703,
  '200': 693,
  '210': 693,
  '220': 693,
  '230': 693,
  '240': 693,
  '250': 683,
  '260': 683,
  '270': 683,
  '280': 683,
  '290': 683,
  '300': 683,
};

const EDEN: { [n: number]: number } = {
  '10': 1118,
  '20': 904,
  '30': 819,
  '40': 751,
  '50': 723,
  '60': 723,
  '70': 722,
  '80': 723,
  '90': 723,
  '100': 723,
  '110': 716,
  '120': 716,
  '130': 716,
  '140': 716,
  '150': 716,
  '160': 689,
  '170': 689,
  '180': 689,
  '190': 689,
  '200': 689,
  '210': 689,
  '220': 689,
  '230': 689,
  '240': 689,
  '250': 689,
  '260': 689,
  '270': 689,
  '280': 689,
  '290': 689,
  '300': 689,
};

const LUMINOUS: { [n: number]: number } = {
  '10': 2352,
  '20': 1750,
  '30': 1391,
  '40': 1179,
  '50': 996,
  '60': 917,
  '70': 859,
  '80': 831,
  '90': 778,
  '100': 751,
  '110': 736,
  '120': 716,
  '130': 710,
  '140': 696,
  '150': 690,
  '160': 684,
  '170': 677,
  '180': 671,
  '190': 665,
  '200': 658,
  '210': 652,
  '220': 646,
  '230': 639,
  '240': 633,
  '250': 627,
  '260': 621,
  '270': 613,
  '280': 606,
  '290': 600,
  '300': 594,
};

const GRACE_TRIFOLD: { [n: number]: number } = {
  '10': 2038,
  '20': 1565,
  '30': 1347,
  '40': 1293,
  '50': 1118,
  '60': 1033,
  '70': 945,
  '80': 896,
  '90': 888,
  '100': 881,
  '110': 849,
  '120': 844,
  '130': 835,
  '140': 821,
  '150': 807,
  '160': 795,
  '170': 786,
  '180': 776,
  '190': 769,
  '200': 762,
  '210': 756,
  '220': 750,
  '230': 744,
  '240': 739,
  '250': 737,
  '260': 732,
  '270': 730,
  '280': 725,
  '290': 722,
  '300': 719,
};

const FLUTTER: { [n: number]: number } = {
  '10': 4194,
  '20': 2942,
  '30': 2412,
  '40': 2078,
  '50': 1856,
  '60': 1750,
  '70': 1587,
  '80': 1497,
  '90': 1415,
  '100': 1330,
  '110': 1277,
  '120': 1233,
  '130': 1190,
  '140': 1163,
  '150': 1137,
  '160': 1133,
  '170': 1130,
  '180': 1106,
  '190': 1103,
  '200': 1100,
  '210': 1077,
  '220': 1075,
  '230': 1073,
  '240': 1050,
  '250': 1048,
  '260': 1047,
  '270': 1045,
  '280': 1023,
  '290': 1022,
  '300': 1021,
};

const KOFFEE: { [n: number]: number } = {
  '10': 3679,
  '20': 2652,
  '30': 2223,
  '40': 1854,
  '50': 1640,
  '60': 1516,
  '70': 1369,
  '80': 1303,
  '90': 1230,
  '100': 1159,
  '110': 1119,
  '120': 1088,
  '130': 1057,
  '140': 1032,
  '150': 1020,
  '160': 1016,
  '170': 1013,
  '180': 1001,
  '190': 999,
  '200': 991,
  '210': 980,
  '220': 978,
  '230': 976,
  '240': 966,
  '250': 965,
  '260': 964,
  '270': 963,
  '280': 952,
  '290': 951,
  '300': 950,
};

const GRACE: { [n: number]: number } = {
  '10': 5328,
  '20': 3384,
  '30': 2652,
  '40': 2224,
  '50': 1939,
  '60': 1801,
  '70': 1673,
  '80': 1613,
  '90': 1556,
  '100': 1485,
  '110': 1446,
  '120': 1405,
  '130': 1383,
  '140': 1343,
  '150': 1325,
  '160': 1318,
  '170': 1313,
  '180': 1296,
  '190': 1292,
  '200': 1282,
  '210': 1267,
  '220': 1264,
  '230': 1261,
  '240': 1247,
  '250': 1244,
  '260': 1242,
  '270': 1237,
  '280': 1223,
  '290': 1222,
  '300': 1220,
};

const ROSE_ET_GRIS: { [n: number]: number } = {
  '10': 5934,
  '20': 3845,
  '30': 2995,
  '40': 2337,
  '50': 1947,
  '60': 1705,
  '70': 1553,
  '80': 1469,
  '90': 1346,
  '100': 1275,
  '110': 1251,
  '120': 1221,
  '130': 1199,
  '140': 1182,
  '150': 1172,
  '160': 1163,
  '170': 1147,
  '180': 1137,
  '190': 1127,
  '200': 1104,
  '210': 1095,
  '220': 1085,
  '230': 1075,
  '240': 1066,
  '250': 1043,
  '260': 1033,
  '270': 1022,
  '280': 1012,
  '290': 1003,
  '300': 993,
};

const MEET_YOU_AT_THE_ARCH: { [n: number]: number } = {
  '10': 4550,
  '20': 3073,
  '30': 2444,
  '40': 2012,
  '50': 1761,
  '60': 1639,
  '70': 1513,
  '80': 1453,
  '90': 1374,
  '100': 1308,
  '110': 1265,
  '120': 1227,
  '130': 1203,
  '140': 1178,
  '150': 1172,
  '160': 1166,
  '170': 1162,
  '180': 1157,
  '190': 1153,
  '200': 1144,
  '210': 1141,
  '220': 1138,
  '230': 1136,
  '240': 1133,
  '250': 1131,
  '260': 1129,
  '270': 1125,
  '280': 1124,
  '290': 1122,
  '300': 1120,
};

const DELICATE_LUXE: { [n: number]: number } = {
  '10': 4351,
  '20': 3073,
  '30': 2385,
  '40': 1928,
  '50': 1659,
  '60': 1532,
  '70': 1403,
  '80': 1339,
  '90': 1257,
  '100': 1188,
  '110': 1143,
  '120': 1102,
  '130': 1077,
  '140': 1050,
  '150': 1043,
  '160': 1038,
  '170': 1033,
  '180': 1028,
  '190': 1024,
  '200': 1015,
  '210': 1011,
  '220': 1008,
  '230': 1005,
  '240': 1003,
  '250': 1000,
  '260': 998,
  '270': 994,
  '280': 992,
  '290': 990,
  '300': 989,
};

const LAVENDER_LEAVES: { [n: number]: number } = {
  '10': 819,
  '20': 605,
  '30': 520,
  '40': 452,
  '50': 424,
  '60': 424,
  '70': 423,
  '80': 424,
  '90': 424,
  '100': 424,
  '110': 417,
  '120': 417,
  '130': 417,
  '140': 417,
  '150': 417,
  '160': 390,
  '170': 390,
  '180': 390,
  '190': 390,
  '200': 390,
  '210': 390,
  '220': 390,
  '230': 390,
  '240': 390,
  '250': 390,
  '260': 390,
  '270': 390,
  '280': 390,
  '290': 390,
  '300': 390,
};

const WHITE_GARDEN: { [n: number]: number } = {
  '10': 819,
  '20': 605,
  '30': 520,
  '40': 452,
  '50': 424,
  '60': 424,
  '70': 423,
  '80': 424,
  '90': 424,
  '100': 424,
  '110': 417,
  '120': 417,
  '130': 417,
  '140': 417,
  '150': 417,
  '160': 390,
  '170': 390,
  '180': 390,
  '190': 390,
  '200': 390,
  '210': 390,
  '220': 390,
  '230': 390,
  '240': 390,
  '250': 390,
  '260': 390,
  '270': 390,
  '280': 390,
  '290': 390,
  '300': 390,
};

const GOLD_FOIL_FRAME: { [n: number]: number } = {
  '10': 1301,
  '20': 1161,
  '30': 1038,
  '40': 871,
  '50': 676,
  '60': 631,
  '70': 586,
  '80': 558,
  '90': 530,
  '100': 503,
  '110': 491,
  '120': 480,
  '130': 464,
  '140': 458,
  '150': 452,
  '160': 447,
  '170': 441,
  '180': 436,
  '190': 430,
  '200': 424,
  '210': 419,
  '220': 419,
  '230': 419,
  '240': 419,
  '250': 419,
  '260': 419,
  '270': 419,
  '280': 419,
  '290': 419,
  '300': 419,
};

const GARDEN_WINDOW: { [n: number]: number } = {
  '10': 819,
  '20': 605,
  '30': 520,
  '40': 452,
  '50': 424,
  '60': 424,
  '70': 423,
  '80': 424,
  '90': 424,
  '100': 424,
  '110': 417,
  '120': 417,
  '130': 417,
  '140': 417,
  '150': 417,
  '160': 390,
  '170': 390,
  '180': 390,
  '190': 390,
  '200': 390,
  '210': 390,
  '220': 390,
  '230': 390,
  '240': 390,
  '250': 390,
  '260': 390,
  '270': 390,
  '280': 390,
  '290': 390,
  '300': 390,
};

const LOVE_AND_LEAVES: { [n: number]: number } = {
  '10': 819,
  '20': 605,
  '30': 520,
  '40': 452,
  '50': 424,
  '60': 424,
  '70': 423,
  '80': 424,
  '90': 424,
  '100': 424,
  '110': 417,
  '120': 417,
  '130': 417,
  '140': 417,
  '150': 417,
  '160': 390,
  '170': 390,
  '180': 390,
  '190': 390,
  '200': 390,
  '210': 390,
  '220': 390,
  '230': 390,
  '240': 390,
  '250': 390,
  '260': 390,
  '270': 390,
  '280': 390,
  '290': 390,
  '300': 390,
};

const LUNA_GATEFOLD: { [n: number]: number } = {
  '10': 923,
  '20': 709,
  '30': 624,
  '40': 556,
  '50': 528,
  '60': 528,
  '70': 527,
  '80': 528,
  '90': 528,
  '100': 528,
  '110': 521,
  '120': 521,
  '130': 521,
  '140': 521,
  '150': 521,
  '160': 494,
  '170': 494,
  '180': 494,
  '190': 494,
  '200': 494,
  '210': 494,
  '220': 494,
  '230': 494,
  '240': 494,
  '250': 494,
  '260': 494,
  '270': 494,
  '280': 494,
  '290': 494,
  '300': 494,
};

const EUCALYPTUS: { [n: number]: number } = {
  '10': 819,
  '20': 605,
  '30': 520,
  '40': 452,
  '50': 424,
  '60': 424,
  '70': 423,
  '80': 424,
  '90': 424,
  '100': 424,
  '110': 417,
  '120': 417,
  '130': 417,
  '140': 417,
  '150': 417,
  '160': 390,
  '170': 390,
  '180': 390,
  '190': 390,
  '200': 390,
  '210': 390,
  '220': 390,
  '230': 390,
  '240': 390,
  '250': 390,
  '260': 390,
  '270': 390,
  '280': 390,
  '290': 390,
  '300': 390,
};

const GRAPHITE_BLOOMS: { [n: number]: number } = {
  '10': 897,
  '20': 683,
  '30': 598,
  '40': 530,
  '50': 502,
  '60': 502,
  '70': 501,
  '80': 502,
  '90': 502,
  '100': 502,
  '110': 495,
  '120': 495,
  '130': 495,
  '140': 495,
  '150': 495,
  '160': 468,
  '170': 468,
  '180': 468,
  '190': 468,
  '200': 468,
  '210': 468,
  '220': 468,
  '230': 468,
  '240': 468,
  '250': 468,
  '260': 468,
  '270': 468,
  '280': 468,
  '290': 468,
  '300': 468,
};

const MODERN_SIMPLICITY: { [n: number]: number } = {
  '10': 1327,
  '20': 1187,
  '30': 1064,
  '40': 897,
  '50': 702,
  '60': 657,
  '70': 612,
  '80': 584,
  '90': 556,
  '100': 529,
  '110': 517,
  '120': 506,
  '130': 490,
  '140': 484,
  '150': 478,
  '160': 473,
  '170': 467,
  '180': 462,
  '190': 456,
  '200': 450,
  '210': 445,
  '220': 445,
  '230': 445,
  '240': 445,
  '250': 445,
  '260': 445,
  '270': 445,
  '280': 445,
  '290': 445,
  '300': 445,
};

const IVORY_GARDEN: { [n: number]: number } = {
  '10': 923,
  '20': 709,
  '30': 624,
  '40': 556,
  '50': 528,
  '60': 528,
  '70': 527,
  '80': 528,
  '90': 528,
  '100': 528,
  '110': 521,
  '120': 521,
  '130': 521,
  '140': 521,
  '150': 521,
  '160': 494,
  '170': 494,
  '180': 494,
  '190': 494,
  '200': 494,
  '210': 494,
  '220': 494,
  '230': 494,
  '240': 494,
  '250': 494,
  '260': 494,
  '270': 494,
  '280': 494,
  '290': 494,
  '300': 494,
};

const GARDEN_ESTATE: { [n: number]: number } = {
  '10': 1327,
  '20': 1187,
  '30': 1064,
  '40': 897,
  '50': 702,
  '60': 657,
  '70': 612,
  '80': 584,
  '90': 556,
  '100': 529,
  '110': 517,
  '120': 506,
  '130': 490,
  '140': 484,
  '150': 478,
  '160': 473,
  '170': 467,
  '180': 462,
  '190': 456,
  '200': 450,
  '210': 445,
  '220': 445,
  '230': 445,
  '240': 445,
  '250': 445,
  '260': 445,
  '270': 445,
  '280': 445,
  '290': 445,
  '300': 445,
};

const BOTANICAL_GEO: { [n: number]: number } = {
  10: 923,
  20: 709,
  30: 624,
  40: 556,
  50: 528,
  60: 528,
  70: 527,
  80: 528,
  90: 528,
  100: 528,
  110: 521,
  120: 521,
  130: 521,
  140: 521,
  150: 521,
  160: 494,
  170: 494,
  180: 494,
  190: 494,
  200: 494,
  210: 494,
  220: 494,
  230: 494,
  240: 494,
  250: 494,
  260: 494,
  270: 494,
  280: 494,
  290: 494,
  300: 494,
};

// Save the Dates

const LUNA: { [n: number]: number } = {
  10: 1433,
  20: 848,
  30: 616,
  40: 490,
  50: 403,
  60: 377,
  70: 356,
  80: 339,
  90: 319,
  100: 303,
  110: 296,
  120: 281,
  130: 278,
  140: 269,
  150: 266,
  160: 264,
  170: 262,
  180: 260,
  190: 259,
  200: 257,
  210: 256,
  220: 255,
  230: 254,
  240: 252,
  250: 252,
  260: 251,
  270: 249,
  280: 248,
  290: 247,
  300: 247,
};

const MINIMALISME: { [n: number]: number } = {
  10: 1791,
  20: 1060,
  30: 771,
  40: 613,
  50: 504,
  60: 471,
  70: 444,
  80: 423,
  90: 399,
  100: 379,
  110: 369,
  120: 351,
  130: 347,
  140: 337,
  150: 333,
  160: 330,
  170: 328,
  180: 325,
  190: 323,
  200: 321,
  210: 320,
  220: 318,
  230: 317,
  240: 316,
  250: 315,
  260: 314,
  270: 311,
  280: 310,
  290: 309,
  300: 309,
};

const SUMMER_MONTAGE: { [n: number]: number } = {
  '10': 1469,
  '20': 869,
  '30': 632,
  '40': 502,
  '50': 413,
  '60': 387,
  '70': 364,
  '80': 347,
  '90': 327,
  '100': 311,
  '110': 303,
  '120': 288,
  '130': 285,
  '140': 276,
  '150': 273,
  '160': 271,
  '170': 269,
  '180': 267,
  '190': 265,
  '200': 263,
  '210': 263,
  '220': 261,
  '230': 260,
  '240': 259,
  '250': 258,
  '260': 257,
  '270': 255,
  '280': 254,
  '290': 253,
  '300': 253,
};

const SUMMER_NIGHTS: { [n: number]: number } = {
  '10': 1469,
  '20': 869,
  '30': 632,
  '40': 502,
  '50': 413,
  '60': 387,
  '70': 364,
  '80': 347,
  '90': 327,
  '100': 311,
  '110': 303,
  '120': 288,
  '130': 285,
  '140': 276,
  '150': 273,
  '160': 271,
  '170': 269,
  '180': 267,
  '190': 265,
  '200': 263,
  '210': 263,
  '220': 261,
  '230': 260,
  '240': 259,
  '250': 258,
  '260': 257,
  '270': 255,
  '280': 254,
  '290': 253,
  '300': 253,
};

const LINEAR: { [n: number]: number } = {
  '10': 1053,
  '20': 852,
  '30': 708,
  '40': 564,
  '50': 483,
  '60': 425,
  '70': 387,
  '80': 390,
  '90': 384,
  '100': 368,
  '110': 368,
  '120': 368,
  '130': 368,
  '140': 355,
  '150': 355,
  '160': 355,
  '170': 355,
  '180': 355,
  '190': 355,
  '200': 348,
  '210': 348,
  '220': 348,
  '230': 348,
  '240': 348,
  '250': 348,
  '260': 348,
  '270': 348,
  '280': 348,
  '290': 348,
  '300': 348,
};

const POLAROID: { [n: number]: number } = {
  '10': 835,
  '20': 537,
  '30': 403,
  '40': 326,
  '50': 269,
  '60': 262,
  '70': 254,
  '80': 247,
  '90': 236,
  '100': 226,
  '110': 223,
  '120': 213,
  '130': 213,
  '140': 208,
  '150': 208,
  '160': 208,
  '170': 208,
  '180': 208,
  '190': 208,
  '200': 208,
  '210': 208,
  '220': 208,
  '230': 208,
  '240': 208,
  '250': 208,
  '260': 208,
  '270': 207,
  '280': 207,
  '290': 207,
  '300': 207,
};

const DELILAH: { [n: number]: number } = {
  '10': 1226,
  '20': 842,
  '30': 651,
  '40': 497,
  '50': 408,
  '60': 347,
  '70': 305,
  '80': 300,
  '90': 288,
  '100': 271,
  '110': 267,
  '120': 264,
  '130': 261,
  '140': 247,
  '150': 245,
  '160': 243,
  '170': 242,
  '180': 240,
  '190': 239,
  '200': 232,
  '210': 231,
  '220': 230,
  '230': 229,
  '240': 229,
  '250': 228,
  '260': 227,
  '270': 227,
  '280': 226,
  '290': 226,
  '300': 225,
};

const FLOWERET: { [n: number]: number } = {
  '10': 1226,
  '20': 842,
  '30': 651,
  '40': 497,
  '50': 408,
  '60': 347,
  '70': 305,
  '80': 300,
  '90': 288,
  '100': 271,
  '110': 267,
  '120': 264,
  '130': 261,
  '140': 247,
  '150': 245,
  '160': 243,
  '170': 242,
  '180': 240,
  '190': 239,
  '200': 232,
  '210': 231,
  '220': 230,
  '230': 229,
  '240': 229,
  '250': 228,
  '260': 227,
  '270': 227,
  '280': 226,
  '290': 226,
  '300': 225,
};

const MINIMALIST_BLACK_WHITE: { [n: number]: number } = {
  '10': 962,
  '20': 851,
  '30': 670,
  '40': 579,
  '50': 481,
  '60': 418,
  '70': 383,
  '80': 363,
  '90': 342,
  '100': 314,
  '110': 279,
  '120': 272,
  '130': 265,
  '140': 258,
  '150': 251,
  '160': 244,
  '170': 237,
  '180': 230,
  '190': 223,
  '200': 216,
  '210': 209,
  '220': 209,
  '230': 209,
  '240': 209,
  '250': 209,
  '260': 209,
  '270': 209,
  '280': 209,
  '290': 209,
  '300': 209,
};

const BYRON: { [n: number]: number } = {
  '10': 986,
  '20': 872,
  '30': 687,
  '40': 593,
  '50': 493,
  '60': 429,
  '70': 393,
  '80': 372,
  '90': 350,
  '100': 322,
  '110': 286,
  '120': 279,
  '130': 272,
  '140': 264,
  '150': 258,
  '160': 250,
  '170': 243,
  '180': 236,
  '190': 229,
  '200': 222,
  '210': 214,
  '220': 214,
  '230': 214,
  '240': 214,
  '250': 214,
  '260': 214,
  '270': 214,
  '280': 214,
  '290': 214,
  '300': 214,
};

const CLAIR_DE_LUNE: { [n: number]: number } = {
  '10': 1444,
  '20': 944,
  '30': 705,
  '40': 542,
  '50': 451,
  '60': 411,
  '70': 378,
  '80': 349,
  '90': 341,
  '100': 327,
  '110': 313,
  '120': 299,
  '130': 299,
  '140': 299,
  '150': 299,
  '160': 299,
  '170': 288,
  '180': 286,
  '190': 286,
  '200': 286,
  '210': 286,
  '220': 286,
  '230': 286,
  '240': 286,
  '250': 286,
  '260': 286,
  '270': 286,
  '280': 286,
  '290': 286,
  '300': 286,
};

export const formatter = new CurrencyFormatter({ locale: 'en', defaultCurrency: 'USD' });

export type QuantityPriceConfig = {
  quantity: number;
  totalPriceInMinorUnits: number;
  individualPriceString: string;
  totalPriceString: string;
};

const _generatePriceConfig = ({ getIndividualPriceByQuantityInMinorUnits }: { getIndividualPriceByQuantityInMinorUnits: (quantity: number) => number }) => {
  const configByQuantity: Record<number, QuantityPriceConfig> = {};
  times(300 / 10, num => {
    const quantity = (num + 1) * 10;
    const individPriceInMinorUnits = getIndividualPriceByQuantityInMinorUnits(quantity);
    const totalPriceInMinorUnits = quantity * individPriceInMinorUnits;

    const config: QuantityPriceConfig = {
      quantity,
      totalPriceInMinorUnits,
      individualPriceString: formatter.formatCurrency(individPriceInMinorUnits / 100, { form: 'auto' }),
      totalPriceString: formatter.formatCurrency(totalPriceInMinorUnits / 100, { form: 'auto' }),
    };

    configByQuantity[quantity] = config;
  });

  return configByQuantity;
};

export type ConciergeServiceCategory = StationeryTemplateCategoryEnum.invitation | StationeryTemplateCategoryEnum.saveTheDate;

export const isConciergeServiceCategory = (category: StationeryTemplateCategoryEnum): category is ConciergeServiceCategory => {
  return [StationeryTemplateCategoryEnum.invitation, StationeryTemplateCategoryEnum.saveTheDate].includes(category);
};

type PriceConfigItem = Record<
  number,
  {
    quantity: number;
    totalPriceInMinorUnits: number;
    individualPriceString: string;
    totalPriceString: string;
  }
>;

type PriceConfig = {
  [StationeryTemplateCategoryEnum.invitation]: {
    quantity: {
      [key in ConciergeInvitationProduct]: PriceConfigItem;
    };
    upgrades?: {
      [k: string]: PriceConfigItem;
    };
  };
  [StationeryTemplateCategoryEnum.saveTheDate]: {
    quantity: {
      [key in ConciergeSaveTheDateProduct]: PriceConfigItem;
    };
    upgrades?: {
      [k: string]: PriceConfigItem;
    };
  };
};

export const PRICE_CONFIG: PriceConfig = {
  [StationeryTemplateCategoryEnum.invitation]: {
    quantity: {
      julyTrifold: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return JULY_TRIFOLD[quantity];
        },
      }),
      wildestDream: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return WILDEST_DREAM[quantity];
        },
      }),
      together: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return TOGETHER[quantity];
        },
      }),
      sofia: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return SOFIA[quantity];
        },
      }),
      sage: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return SAGE[quantity];
        },
      }),
      milkAndHoney: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MILK_AND_HONEY[quantity];
        },
      }),
      jardin: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return JARDIN[quantity];
        },
      }),
      ivory: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return IVORY[quantity];
        },
      }),
      harmony: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return HARMONY[quantity];
        },
      }),
      harmonyGatefold: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return HARMONY_GATEFOLD[quantity];
        },
      }),
      empireNow: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return EMPIRE_NOW[quantity];
        },
      }),
      byronGatefold: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return BYRON_GATEFOLD[quantity];
        },
      }),
      celadon: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return CELADON[quantity];
        },
      }),
      wildMeadow: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return WILD_MEADOW[quantity];
        },
      }),
      eden: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return EDEN[quantity];
        },
      }),
      luminous: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LUMINOUS[quantity];
        },
      }),
      graceTrifold: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GRACE_TRIFOLD[quantity];
        },
      }),
      flutter: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return FLUTTER[quantity];
        },
      }),
      koffee: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return KOFFEE[quantity];
        },
      }),
      grace: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GRACE[quantity];
        },
      }),
      roseEtGris: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return ROSE_ET_GRIS[quantity];
        },
      }),
      meetYouAtTheArch: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MEET_YOU_AT_THE_ARCH[quantity];
        },
      }),
      delicateLuxe: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return DELICATE_LUXE[quantity];
        },
      }),
      lavenderLeaves: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LAVENDER_LEAVES[quantity];
        },
      }),
      whiteGarden: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return WHITE_GARDEN[quantity];
        },
      }),
      goldFoilFrame: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GOLD_FOIL_FRAME[quantity];
        },
      }),
      gardenWindow: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GARDEN_WINDOW[quantity];
        },
      }),
      loveAndLeaves: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LOVE_AND_LEAVES[quantity];
        },
      }),
      lunaGatefold: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LUNA_GATEFOLD[quantity];
        },
      }),
      eucalyptus: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return EUCALYPTUS[quantity];
        },
      }),
      graphiteBlooms: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GRAPHITE_BLOOMS[quantity];
        },
      }),
      modernSimplicity: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MODERN_SIMPLICITY[quantity];
        },
      }),
      ivoryGarden: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return IVORY_GARDEN[quantity];
        },
      }),
      gardenEstate: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GARDEN_ESTATE[quantity];
        },
      }),
      botanicalGeo: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return BOTANICAL_GEO[quantity];
        },
      }),
    },
  },
  [StationeryTemplateCategoryEnum.saveTheDate]: {
    upgrades: {
      magnetic: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: () => {
          return 99;
        },
      }),
    },
    quantity: {
      luna: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LUNA[quantity];
        },
      }),
      minimalisme: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MINIMALISME[quantity];
        },
      }),
      summerMontage: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return SUMMER_MONTAGE[quantity];
        },
      }),
      summerNights: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return SUMMER_NIGHTS[quantity];
        },
      }),
      linear: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LINEAR[quantity];
        },
      }),
      polaroid: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return POLAROID[quantity];
        },
      }),
      delilah: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return DELILAH[quantity];
        },
      }),
      floweret: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return FLOWERET[quantity];
        },
      }),
      minimalistBlackWhite: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MINIMALIST_BLACK_WHITE[quantity];
        },
      }),
      byron: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return BYRON[quantity];
        },
      }),
      clairDeLune: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return CLAIR_DE_LUNE[quantity];
        },
      }),
    },
  },
};
